import { Deserializable } from '../../protocols/deserializable';

export const DEFAULT_TEXT_COLOR = '#000000';
export const DEFAULT_BACKGROUND_COLOR = '#FFFFFF';

export class MenuOptions implements Deserializable {
  // Zoom
  public productZoom: number = 1;
  public titleZoom: number = 1;
  // Hide
  public hideTitle: boolean = false;
  public hideLabel: boolean = false;
  public hidePriceDecimal: boolean = false;
  public hideLogo: boolean = false;
  // Show
  public showAltLogo: boolean = false;
  // Colors
  public blurredBackground: boolean = false;
  public backgroundOpacity: number = 0;
  public titleTextColor: string = DEFAULT_TEXT_COLOR;
  public bodyTextColor: string = DEFAULT_TEXT_COLOR;
  public bodyBackgroundColor: string = DEFAULT_BACKGROUND_COLOR;
  // Formatting
  public sectionMarginTop: number = 0;
  public sectionMarginBottom: number = 0;
  // Print Options
  public sectionPageBreak: boolean = false;

  onDeserialize() {
    if (this.titleTextColor === '') {
      this.titleTextColor = DEFAULT_TEXT_COLOR;
    }
    if (this.bodyTextColor === '') {
      this.bodyTextColor = DEFAULT_TEXT_COLOR;
    }
    if (this.bodyBackgroundColor === '') {
      this.bodyBackgroundColor = DEFAULT_BACKGROUND_COLOR;
    }
  }
}
